import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import { instrumentTypes } from 'src/app/components/casos/ver-tarea/components/ras/utils/instrumentTypes';

@Injectable({
  providedIn: 'root',
})
export class FindSucursalDataService {
  constructor(private readonly http: HttpClient) {}
  async takeData(value) {
    const { workbook, worksheet } = await this.initWorkbookExcel();
    return this.returnData(worksheet, value);
  }
  async initWorkbookExcel() {
    const workbook = new Workbook();
    await this.importExcelRAS(workbook);
    return { workbook, worksheet: workbook.getWorksheet('Hoja1') };
  }

  async importExcelRAS(workbook) {
    let formFile: any = await this.http
      .get('assets/file/Directory.xlsx', {
        observe: 'response',
        responseType: 'blob',
      })
      .toPromise();
    formFile = formFile.body;
    await workbook.xlsx.load(formFile);
  }
  returnData(worksheet, value) {
    let number = 2;
    let index = 0;
    while (value != worksheet.getCell(`B${number}`)) {
      index = worksheet.getCell(`B${number}`);
      number++;
    }
    return {
      tlf: worksheet.getCell(`G${number}`).value,
      dir: worksheet.getCell(`F${number}`).value,
    };
  }
}
